/**
 * Δ for one line: filed minus computed.
 *
 * Returns null in two cases:
 *  1. computed[key] is not a number (nothing to compare against).
 *  2. filed[key] is absent or null (the line has not yet been filed — no misleading pre-filing delta).
 *
 * An explicitly entered 0 (`filed[key] === 0`) IS a real value and WILL produce a delta,
 * distinguishing "entered zero" from "not yet entered".
 */
export function lineVariance(
  computed: Record<string, number | null> | undefined,
  filed: Record<string, number | null> | undefined,
  key: string,
): number | null {
  const c = computed?.[key];
  if (typeof c !== 'number') return null;
  const f = filed?.[key];
  if (typeof f !== 'number') return null; // absent or null → not yet filed
  return f - c;
}
